import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import { Alert, Box, Button, CircularProgress } from '@mui/material';
import { teacherModuleAPI } from '../../services/api';
import { buildBatchSessionPath } from '../../utils/teacherSessionNavigation';

/**
 * Legacy route `/teacher/sessions/:sessionId` — redirects to the batch session panel
 * so makeup and regular classes share the same teacher experience.
 */
const TeacherSessionDetail = () => {
  const { sessionId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const detailQuery = useQuery(
    ['teacherSessionDetail', sessionId],
    async () => {
      const res = await teacherModuleAPI.getSessionDetail(sessionId);
      return res.data?.data;
    },
    { enabled: !!sessionId, retry: 1 }
  );

  const batchId = detailQuery.data?.session?.batch_id;

  useEffect(() => {
    if (!batchId || !sessionId) return;
    const target = buildBatchSessionPath(batchId, sessionId);
    const suffix = location.search || '';
    navigate(`${target}${suffix}`, { replace: true });
  }, [batchId, sessionId, navigate, location.search]);

  if (detailQuery.isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (detailQuery.isError || !detailQuery.data?.session) {
    return (
      <Box sx={{ p: 2 }}>
        <Alert severity="error">Session not found.</Alert>
        <Button onClick={() => navigate('/teacher/home')} sx={{ mt: 2 }}>
          Back to Teacher Home
        </Button>
      </Box>
    );
  }

  if (!batchId) {
    return (
      <Box sx={{ p: 2 }}>
        <Alert severity="warning">This session is not linked to a batch.</Alert>
        <Button onClick={() => navigate('/teacher/home')} sx={{ mt: 2 }}>
          Back to Teacher Home
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
      <CircularProgress />
    </Box>
  );
};

export default TeacherSessionDetail;
